import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import { ReportKinds } from "../../../../../model/reports/types/ReportsKinds.enum";
import { EntityIcons } from "../../../../../utils/GlobalIcons";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faClock } from "@fortawesome/free-regular-svg-icons/faClock";
import { faTasks } from "@fortawesome/free-solid-svg-icons/faTasks";

export const entryMetricKeys = [
  ReportKinds.ENTRY,
  ReportKinds.ENTRY_LEAD,
  ReportKinds.ENTRY_CONTACT,
  ReportKinds.ENTRY_JUNK,
];
export const dealMetricKeys = [
  ReportKinds.DEAL,
  ReportKinds.DEAL_WON,
  ReportKinds.DEAL_LOST,
  ReportKinds.DEAL_TO_COMPETITION,
];
export const taskMetricKeys = [
  ReportKinds.TASK,
  ReportKinds.TASK_PENDING,
  ReportKinds.TASK_COMPLETED,
];

export const widgetTitleIconsAndColors = {
  [ReportKinds.ENTRY]: { icon: EntityIcons.Entries, color: "black" },
  [ReportKinds.ENTRY_LEAD]: { icon: faCircle, color: "lead" },
  [ReportKinds.ENTRY_CONTACT]: { icon: faCircle, color: "contact" },
  [ReportKinds.ENTRY_JUNK]: { icon: faCircle, color: "junk" },
  [ReportKinds.DEAL]: { icon: EntityIcons.Deals, color: "black" },
  [ReportKinds.DEAL_WON]: { icon: faCheckCircle, color: "success" },
  [ReportKinds.DEAL_LOST]: { icon: faTimesCircle, color: "danger" },
  [ReportKinds.DEAL_TO_COMPETITION]: { icon: faTimesCircle, color: "warning" },
  [ReportKinds.TASK]: { icon: EntityIcons.Tasks, color: "black" },
  [ReportKinds.TASK_PENDING]: { icon: faClock, color: "warning" },
  [ReportKinds.TASK_COMPLETED]: { icon: faTasks, color: "success" },
};
